
import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface NavigationButtonsProps {
  step: number;
  totalSteps: number;
  handleBack: () => void;
  handleNext: () => void;
  handleSubmit: () => void;
  isSubmitting: boolean;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  step,
  totalSteps,
  handleBack,
  handleNext,
  handleSubmit,
  isSubmitting
}) => {
  return (
    <div className="flex justify-between mt-8">
      {step > 1 ? (
        <Button variant="outline" onClick={handleBack} disabled={isSubmitting}>
          Back
        </Button>
      ) : (
        <div></div>
      )}
      
      {step < totalSteps ? (
        <Button onClick={handleNext} className="group">
          Next
          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Button>
      ) : (
        <Button 
          onClick={handleSubmit} 
          disabled={isSubmitting}
          className="group"
        >
          {isSubmitting ? "Creating Profile..." : "Complete Setup"}
          {!isSubmitting && <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />}
        </Button>
      )}
    </div>
  );
};

export default NavigationButtons;
